<template>
    <template v-if="IsMobile">
        <VarDrag class="ai-popup-body" id="drag" ref="dragRef" style="right: 30px; top: 230px;" @click="Open">
            <var-progress class="progress-box" mode="circle" type="success" label :value="100" :line-width="7.5"
                :size="75" :color="{
                    '0%': '#3fecff',
                    '100%': '#6149f6',
                }">
                <VarImage v-if="taskStatisticeStore.HasAi" v-ripple radius="50%" width="65px" height="65px" fit="cover"
                    :src="require('@/assets/images/ai_work.gif')">
                </VarImage>
                <VarImage v-else v-ripple radius="50%" width="65px" height="65px" fit="cover"
                    :src="require('@/assets/images/ai_sleep.gif')">
                </VarImage>

                <div class="drag-text-content" v-ripple>
                    <VarSpace direction="column">
                        <template v-if="taskStatisticeStore.HasAi">
                            <VarSpace justify="center" align="center" direction="column" size="5">
                                <span class="ai-name">AI</span>
                            </VarSpace>
                        </template>
                        <template v-else>

                        </template>
                    </VarSpace>
                </div>
            </var-progress>
        </VarDrag>
    </template>
    <template v-else>
        <div class="pc-ai-popup-body" id="drag" ref="dragRef" @click="Open">
            <var-progress class="progress-box" mode="circle" type="success" label :value="100" :line-width="5.5"
                :size="50" :color="{
                    '0%': '#3fecff',
                    '100%': '#6149f6',
                }">
                <VarImage v-if="taskStatisticeStore.HasAi" v-ripple radius="50%" width="50px" height="50px" fit="cover"
                    :src="require('@/assets/images/ai_work.gif')">
                </VarImage>
                <VarImage v-else v-ripple radius="50%" width="50px" height="50px" fit="cover"
                    :src="require('@/assets/images/ai_sleep.gif')">
                </VarImage>
                <div class="drag-text-content" v-ripple>
                    <VarSpace direction="column">
                        <template v-if="taskStatisticeStore.HasAi">
                            <VarSpace justify="center" align="center" direction="column" size="5">
                                <span class="ai-name">AI</span>
                            </VarSpace>
                        </template>
                        <template v-else>

                        </template>
                    </VarSpace>
                </div>
            </var-progress>
        </div>
    </template>

</template>

<script setup lang="tsx">
import { useSystemConfigStore } from '@/store/SystemConfigStore';
import { useAiOrderStore } from '@/store/AiOrderTaskStore';
import { useUserStore } from '@/store/UserStore';
import SignalRService from '@/typescript/Services/SignalRService';
import { _DragComponent } from '@varlet/ui';
import { inject, onMounted, ref, watch } from 'vue';
import { useTaskStatisticeStore } from '@/store/TaskStatisticeStore';
const dragRef = ref<_DragComponent>();
const aiOrderStore = useAiOrderStore();
const taskStatisticeStore = useTaskStatisticeStore(); //统计用
const userData = useUserStore();
const IsMobile = inject<boolean>("IsMobile");
const systemConfigStore = useSystemConfigStore();

/**
 * 打开任务详情
 */
function Open() {
    aiOrderStore.show = true;
}



onMounted(() => {
    // const drag = document.querySelector('#drag') as HTMLDivElement;
    // const top = 100;
    // const left = globalThis.innerWidth - drag.clientWidth;
    // drag.style = `left: ${left}px; top: ${top}px;`;
});


</script>
<style lang="scss" scoped>
.ai-popup-body {
    .progress-box {
        position: relative;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;

        .drag-bg {
            background-color: var(--card-background);
            width: 55px;
            height: 55px;
            border-radius: 50%;
            overflow: hidden;
        }

        .drag-text-content {
            overflow: hidden;
            border-radius: 50%;
            position: absolute;
            display: flex;
            align-items: center;
            justify-content: center;
            top: 0px !important;
            left: 0px !important;
            height: 55px;
            width: 55px;
            font-size: 12px;
            font-weight: bold;
            color: white;

            .ai-name {
                font-size: 16px;
            }

            .ai-value {
                font-size: 14px;
            }
        }
    }
}

.pc-ai-popup-body {
    display: flex;
    margin: 0px 20px;
    .progress-box {
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;

        .drag-bg {
            background-color: var(--card-background);
            width: 50px;
            height: 50px;
            border-radius: 50%;
            overflow: hidden;
        }

        .drag-text-content {
            overflow: hidden;
            border-radius: 50%;
            position: absolute;
            display: flex;
            align-items: center;
            justify-content: center;
            top: 0px !important;
            left: 0px !important;
            height: 50px;
            width: 50px;
            font-size: 12px;
            font-weight: bold;
            color: white;

            .ai-name {
                font-size: 16px;
            }

            .ai-value {
                font-size: 14px;
            }
        }
    }
}
</style>